<div>
    <p class="text-uppercase mt-5" [innerHTML]="oneColAreaNoButton_params.preTitle"></p>
    <h1 class="titulo" [innerHTML]="oneColAreaNoButton_params.title"></h1>
    <p [innerHTML]="oneColAreaNoButton_params.mainText"></p>

</div>